import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-card-with-header',
  imports: [CommonModule],
  templateUrl: './card-with-header.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./card-with-header.component.scss']
})
export class CardWithHeaderComponent {
  @Input() title: string = ''
  @Input() color: string = ''
  @Input() headerOnly: boolean = false;
}
